<div class="flex flex-col gap-4 bg-white rounded-lg p-4">
  <div class="flex items-center justify-between border-b border-grayed-100 pb-3">
    <button type="button" class="size-8 cursor-pointer" aria-label="Previous month" (click)="previousMonth()">
      &laquo;
    </button>
    <span class="font-semibold text-black capitalize">{{ monthLabel() }}</span>
    <button type="button" class="size-8 cursor-pointer" aria-label="Next month" (click)="nextMonth()">
      &raquo;
    </button>
  </div>

  <div class="grid grid-cols-7 justify-items-center gap-1">
    @for (weekday of weekdays(); track $index; let index = $index) {
      <span
        class="flex size-8 items-center justify-center font-semibold capitalize"
        [class.text-black]="index < 5"
        [class.text-grayed-400]="index >= 5"
      >
        {{ weekday }}
      </span>
    }

    @for (day of days(); track day.date.getTime()) {
      <button
        type="button"
        class="flex size-8 items-center justify-center rounded-md"
        [attr.aria-disabled]="day.disabled"
        [attr.aria-pressed]="day.selected"
        [class.cursor-pointer]="!day.disabled"
        [class.cursor-not-allowed]="day.disabled"
        [class.text-grayed-400]="!day.selected && (day.disabled || !day.inCurrentMonth)"
        [class.text-black]="!day.selected && !day.disabled && day.inCurrentMonth"
        [class.bg-grayed-100]="day.today && !day.selected"
        [class.bg-black]="day.selected"
        [class.text-white]="day.selected"
        (click)="selectDay(day)"
      >
        {{ day.label }}
      </button>
    }
  </div>
</div>
